<!-- Hero Carouse Starts -->
<section>
    <app-herocarousel> </app-herocarousel>
</section>
<!-- Hero Carouse Ends -->

<!-- Community Section Starts -->
<!-- <section class="community-bg">
    <div class="container text-center">
        <p class=" index-brandnew-text ">Brandnew is democratizing by curating the largest pool of online
            brands from around the world bringing them
            closer to the customer by connecting them to physical retail</p>
        <div class="title text-center py-3">JOIN THE COMMUNITY</div>
        <div class="row justify-content-center py-3">
            <div class="col-5 col-md-2">
                <button class=" btn btn-dark brand-store-btn-group"> I'm a Store</button>
            </div>
            <div class="col-5 col-md-2">
                <button class=" btn btn-dark brand-store-btn-group">I'm a Brand</button>

            </div>
        </div>

    </div>
</section> -->
<!-- Community Section Ends -->

<!-- category carousel starts -->
<!-- <section>
    <app-category-carousel></app-category-carousel>
</section> -->

<!-- category carousel ends -->